import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext';
import './UpgradePlan.css'
import { Plan } from '../../types/types';
import { CardPlan } from '../../molecules/CardPlan/CardPlan';
import mock from '../../../jsonMock/plans.json'
import { getPlansList } from 'api/Api';


export const UpgradePlan = () => {
    const [plans, setPlans] = useState<Plan[]>([])
    const { setLoadingModal, setErrorModal, setClosedModal } = useContext(AppGeneralContext)

    useEffect(() => {
        setLoadingModal()
        getPlansList().then((res) => {

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return false
            }

            const response = res.response
            setPlans(response.plans)
            setClosedModal()
        })

    }, [])

    const showPlans = useMemo(() => {
        return plans.map((plan) => {
            return (
                <div key={plan.id} className='col-xs-12 col-md-6 mb-4'>
                    <CardPlan plan={plan} />
                </div>
            )
        })

    }, [plans])

    return (
        <>

            <div className="row">{showPlans}</div>

        </>
    );
}

